<template>
  <div :style="style">
    <svg width="60" height="60" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <rect x="17.5" y="30" width="15" height="40" :fill="color">
        <animate attributeName="y" repeatCount="indefinite" dur="1s"
          calcMode="spline" keyTimes="0;0.5;1" values="18;30;30"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.2s" />
        <animate attributeName="height" repeatCount="indefinite" dur="1s"
          calcMode="spline" keyTimes="0;0.5;1" values="64;40;40"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.2s" />
      </rect>
      <rect x="42.5" y="30" width="15" height="40" :fill="color">
        <animate attributeName="y" repeatCount="indefinite" dur="1s"
          calcMode="spline" keyTimes="0;0.5;1" values="21;30;30"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.1s" />
        <animate attributeName="height" repeatCount="indefinite" dur="1s"
          calcMode="spline" keyTimes="0;0.5;1" values="58;40;40"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.1s" />
      </rect>
      <rect x="67.5" y="30" width="15" height="40" :fill="color">
        <animate attributeName="y" repeatCount="indefinite" dur="1s"
          calcMode="spline" keyTimes="0;0.5;1" values="21;30;30"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1" />
        <animate attributeName="height" repeatCount="indefinite" dur="1s"
          calcMode="spline" keyTimes="0;0.5;1" values="58;40;40"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1" />
      </rect>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    color: {
      type: String,
      default: '#1890FF'
    }
  },
  computed: {
    style() {
      return {
        margin: '1rem auto',
        textAlign: 'center'
      };
    }
  }
};
</script>
